import { render } from "./table.vue?vue&type=template&id=e28cd0ca&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"

import "./table.vue?vue&type=style&index=0&id=e28cd0ca&lang=css"
import "./table.vue?vue&type=style&index=1&id=e28cd0ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e28cd0ca"]])

export default __exports__